module.exports = __webpack_public_path__ + "img/undraw_Dark_analytics_re_2kvy.18b4c0d6.svg";